import { TasksTaskFragment } from 'generated/resources/graphql'
import sortBy from 'lodash/sortBy'

import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import { isBackendDateOverdue, isBackendDateToday } from 'modules/core/lib/dates'

export type Filter = 'mandatory' | 'optional' | 'overdue'
export type Task = TasksTaskFragment & { mandatory?: boolean }

const useTasksFilter = (tasks?: Task[], filterBy?: Filter) => {
  const allTasks = useUnsafeMemo(() => {
    return sortBy(tasks, (task) => task?.createdAt)
  }, [tasks])

  const filteredTasks = useUnsafeMemo(() => {
    if (filterBy === 'overdue') {
      return allTasks.filter((task) => task?.dueOn && isBackendDateOverdue(task.dueOn))
    }

    if (filterBy === 'mandatory') {
      return allTasks.filter((task) => task?.mandatory)
    }

    if (filterBy === 'optional') {
      return allTasks.filter((task) => !task?.mandatory)
    }

    if (filterBy === 'due_today') {
      return allTasks.filter((task) => task?.dueOn && isBackendDateToday(task.dueOn))
    }

    return allTasks
  }, [allTasks, filterBy])

  const todoTasks = useUnsafeMemo(() => {
    return filteredTasks.filter((task) => !task?.completedAt)
  }, [filteredTasks])

  const doneTasks = useUnsafeMemo(() => {
    return filteredTasks.filter((task) => !!task?.completedAt)
  }, [filteredTasks])

  return {
    allTasks,
    todoTasks,
    doneTasks,
    filteredTasks,
  }
}

export default useTasksFilter
